import { LocalStyles } from "@paperbits/common/styles";

export class SigninModel {
    /**
     * Widget local styles.
     */
    public styles: LocalStyles = {};
}
